import vue from "vue";
import {
  Skeleton,
  TreeSelect,
  ActionSheet,
  Picker,
  Progress,
  DropdownMenu,
  NoticeBar,
  DatetimePicker,
  Cascader,
  Toast,
  Icon,
  Lazyload,
  List,
  Form,
  Button,
  Field,
  Tab,
  Tabs,
  NavBar,
  Col,
  ImagePreview,
  Row,
  Dialog,
  Popup,
  Loading,
  RadioGroup,
  Radio,
  Overlay,
  Divider,
  Uploader,
  PullRefresh,
  Badge,
  Empty,
  Popover,
  Search,
  ShareSheet,
  Image as VanImage,
  Swipe,
  SwipeItem,
  Tag,
  SubmitBar,
  Sku,
  Cell,
  Collapse,
  CollapseItem,
  Steps,
  Step,
  Notify,
  Rate,
  Calendar,
  Checkbox,
  CheckboxGroup,
  Sticky,
  Stepper,
  DropdownItem,
  Tabbar,
  TabbarItem,
  Switch,
  Slider,
  IndexBar,
  IndexAnchor,
  Area,
  Circle,
} from "vant";

vue
  .use(IndexBar)
  .use(Circle)
  .use(IndexAnchor)
  .use(Tabbar)
  .use(Slider)
  .use(TabbarItem)
  .use(Switch)
  .use(Picker)
  .use(Cascader)
  .use(DropdownMenu)
  .use(Lazyload)
  .use(DropdownItem)
  .use(DatetimePicker)
  .use(NoticeBar)
  .use(Stepper)
  .use(Sticky)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Calendar)
  .use(Progress)
  .use(Notify)
  .use(Rate)
  .use(Sku)
  .use(Steps)
  .use(Step)
  .use(Cell)
  .use(Collapse)
  .use(CollapseItem)
  .use(SubmitBar)
  .use(Tag)
  .use(Swipe)
  .use(SwipeItem)
  .use(Toast)
  .use(Loading)
  .use(Icon)
  .use(ShareSheet)
  .use(List)
  .use(Badge)
  .use(Search)
  .use(Empty)
  .use(Form)
  .use(Button)
  .use(Field)
  .use(Dialog)
  .use(ImagePreview)
  .use(VanImage)
  .use(Tab)
  .use(Divider)
  .use(Tabs)
  .use(Overlay)
  .use(NavBar)
  .use(Col)
  .use(Row)
  .use(Radio)
  .use(RadioGroup)
  .use(Popup)
  .use(Uploader)
  .use(NavBar)
  .use(PullRefresh)
  .use(Popover)
  .use(ActionSheet)
  .use(TreeSelect)
  .use(Skeleton)
  .use(Area);
